import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { StringUtilities } from "webshop-modules/string/String.utilities";

export class MainHeaderApplicationDataProvider {

    public static hasProvidedDataFor(scriptTag: ScriptSelector): boolean {
        const script = <HTMLElement>document.querySelector(`[data-js=${scriptTag}-loader-script]`);

        return !!script;
    }

    public static parseProvidedData<T>(scriptTag: ScriptSelector): T  {
        const script = <HTMLElement>document.querySelector(`[data-js=${scriptTag}-loader-script]`);

        return <T>JSON.parse(StringUtilities.unescape(script.innerHTML));
    }
}